import _merge from 'lodash/merge'
import taboola from './taboola'
import taboolaDefaults from './taboolaDefaults'

export default {
  'editionSettings': {
    'key': 'espn-en-au',
    'site': 'espn',
    'language': 'en',
    'country': 'au',
    'domain': 'www.espn.com.au',
    'editionSiteId': '16',
    'https': true
  },
  'navId': '14327376',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'en',
    'region': 'AU'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Monday',
    'timeZone': 'Etc/GMT',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'GMT',
    'timeZoneBucket': 'Australia/Melbourne',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'sponsoredContentProviders': [ 'taboola', 'outbrain' ],
  'taboola': _merge({}, taboolaDefaults, taboola),
  'outbrain': {
    'enabled': true,
    'template': 'ESPNAustralia',
    'desktop': {
      'compliantId': 'AR_49',
      'nonCompliantId': 'AR_12'
    },
    'mobile': {
      'compliantId': 'AR_49',
      'nonCompliantId': 'MB_5'
    },
    'table': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'MB_43'
      }
    },
    'game': {
      'desktop': {
        'compliantId': 'AR_48'
      },
      'mobile': {
        'compliantId': 'AR_48'
      }
    },
    'team': {
      'desktop': {
        'compliantId': 'SB_1'
      },
      'mobile': {
        'compliantId': 'SB_1'
      }
    }
  },
  'omniture': {
    'site': 'espnau',
    'account': 'wdgespaustralia',
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'network': 1234,
    'partnerAd': false,
    'dev-config': 14673100,
    'qa-config': 14673100,
    'prod-config': 14673100
  },
  'partnerModules': {
    'global': false,
    'nba': false,
    'womenbb': false,
    'golf': false,
    'endurance': false,
    'horse': false,
    'nascar': false
  },
  'sportBranding': [ {
    'sport': 'cricket',
    'image': 'logo-uk-cricinfo',
    'url': 'https://www.espncricinfo.com'
  }, {
    'sport': 'soccer',
    'image': 'logo-uk-fc',
    'url': 'http://www.espnfc.com.au'
  }, {
    'sport': 'rugby',
    'image': 'logo-uk-scrum',
    'url': null
  }, {
    'sport': 'ncaaw',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'ncw',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'wnba',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'womenbb',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  } ],
  'siteLogo': {
    'class': 'beta',
    'featurePhone': {
      'name': 'espn-logo',
      'width': 45,
      'height': 11
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for AFL, NRL, NFL, MLB, NBA and more.',
    'defaultMetaImage': 'espn_red.png',
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'en'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com',
        'locale': 'en_US'
      }
    }
  },
  'shop': {
    'enabled': false
  },
  'sportReplacements': {
    'f1': 'f1'
  },
  'uriRewrites': {
    'urls': {
      'toEdition': {},
      'toEnglish': {}
    },
    'roots': {
      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
      '/oly/summer/cycling/': '/oly/summer/cycling/',
      '/american-football/': '/nfl/',
      '/college-football/': '/ncf/',
      '/football/': '/soccer/',
      '/racing/nascar/': '/nascar/',
      '/racing/': '/rpm/',
      '/mens-college-basketball/': '/ncb/',
      '/womens-college-basketball/': '/ncw/',
      '/womens-basketball/': '/womenbb/',
      '/olympics/': '/oly/',
      '/cycling/': '/cycling/',
      '/fixtures/': '/schedule',
      '/figure-skating/': '/oly/',
      '/college-sports/': '/ncaa/',
      '/gymnastics/': '/oly/',
      '/skiing/': '/oly/',
      '/horse-racing/': '/horse/',
      '/sports/womenbb/': '/womenbb/',
      '/sports/horse/': '/horse/'
    },
    'pathSegments': {},
    'paramKeys': {},
    'paramValues': {}
  },
  'betting': {
    'enabled': false,
    'provider': 'Bet 365',
    'game': {
      'enabled': false,
      'provider': 'Bet 365'
    }
  },
  'ticketProvider': null,
  'hasTickets': false,
  'showFavorites': true,
  'showInsider': false,
  'showWatch': false,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': false,
    'teams': false,
    'tags': true
  },
  'showFCContent': false,
  'showCricInfoContent': false,
  'cookieConsent': false,
  'scDeepLinking': true,
  'allowShortUrl': false,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'shimFavorites': true,
  'nowFeed': true,
  'searchUrl': 'http://search.espn.com/',
  'hasSearch': true,
  'gameSettings': {
    'topEventsId': 14323671,
    'promotedSoccerLeaguesCeId': 12032789,
    'showBroadcast': false
  },
  'fallback': {
    'nba': 'espn-en-nba-index',
    'nfl': 'espn-en-nfl-index',
    'nascar': 'espn-en-nascar-index',
    'tennis': 'espn-en-tennis-index',
    'mlb': 'espn-en-mlb-index',
    'nhl': 'espn-en-nhl-index',
    'f1': 'espnuk-en-f1-index',
    'womenbb': 'espn-en-womenbb-index',
    'ncf': 'espn-en-ncf-index',
    'ncb': 'espn-en-ncb-index',
    'ncaa': 'espn-en-ncaa-index',
    'boxing': 'espn-en-boxing-index',
    'mma': 'espn-en-mma-index',
    'esports': 'espn-en-esports-index',
    'cricket': 'espn-en-cricket-index',
    'endurance': 'espn-en-endurance-index',
    'golf': 'espn-en-golf-index',
    'chalk': 'espn-en-chalk-index',
    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
  },
  'editionAlert': {
    'enabled': true,
    'text': "You have reached ESPN's Australian edition. <a href=\"#\" class=\"stay\">Stay on current site</a> or <a href=\"https://www.espn.com/?country-view=us&amp;lang-view=en\">go to US version</a>."
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'Story',
        'HeadlineNews'
      ]
    }
  },
  'tier2NavIds': {
    'boston': 12375278,
    'chicago': 12505826,
    'cleveland': 13977091,
    'dallas': 12505828,
    'los-angeles': 12505831,
    'milwaukee': 13977360,
    'new-york': 12505854,
    'horse-racing': 16987409,
    'fantasy/basketball': 12405600,
    'fantasy/football': 12405632,
    'fantasy/baseball': 12405631,
    'fantasy/hockey': 12405634,
    'fantasy': 13609307,
    'ncfrecruiting': 11588758,
    'ncbrecruiting': 11588880,
    'betting': 16984056,
    'esports': 13663224,
    'onenacion': 13309315,
    'chalk': 14838513,
    'nba/stephen-curry': 14950765,
    'league': {
      'soccer': 13794648,
      'ncf': 13886385,
      'college-football': 13886385,
      'cricket': 15609108
    },
    'oly': 17101944
  },
  'tier3NavIds': {
    'clubhouse': {
      'nba': 12293424,
      'mlb': 12343023,
      'mens-college-basketball': 13884705,
      'womens-college-basketball': 13930164,
      'soccer': 12294454,
      'nfl': 12509708,
      'college-football': 13345157,
      'cricket': 15368856
    }
  },
  'indexAutoStart': false,
  'useMongo': true,
  'activeSite': true,
  'countries': [ {
    'name': 'American Samoa',
    'country-code': 'as',
    'showHreflang': false
  }, {
    'name': 'Australia',
    'country-code': 'au',
    'showHreflang': true
  }, {
    'name': 'Cook Islands',
    'country-code': 'ck',
    'showHreflang': false
  }, {
    'name': 'Fiji',
    'country-code': 'fj',
    'showHreflang': false
  }, {
    'name': 'French Polynesia',
    'country-code': 'pf',
    'showHreflang': false
  }, {
    'name': 'Kiribati',
    'country-code': 'ki',
    'showHreflang': false
  }, {
    'name': 'Marshall Islands',
    'country-code': 'mh',
    'showHreflang': false
  }, {
    'name': 'Micronesia',
    'country-code': 'fm',
    'showHreflang': false
  }, {
    'name': 'Niue',
    'country-code': 'nu',
    'showHreflang': false
  }, {
    'name': 'Palau',
    'country-code': 'pw',
    'showHreflang': false
  }, {
    'name': 'Papua New Guinea',
    'country-code': 'pg',
    'showHreflang': false
  }, {
    'name': 'Tahiti',
    'country-code': 'pf',
    'showHreflang': false
  }, {
    'name': 'Tokelau',
    'country-code': 'tk',
    'showHreflang': false
  }, {
    'name': 'Tonga',
    'country-code': 'to',
    'showHreflang': false
  }, {
    'name': 'Tuvalu',
    'country-code': 'tv',
    'showHreflang': false
  }, {
    'name': 'Western Samoa',
    'country-code': 'ws',
    'showHreflang': false
  } ],
  'analytics' : {
    'site' : 'espnau'
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/australia.js